<div class="sb-step sb-step-customer">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <!-- <sb-promo-banner></sb-promo-banner> -->
        <div class="sb-form-block">
          <div class="sb-form-block__title">
            {{'ENTITY.CUSTOMER-IDENTITY.TITLE' | translate}}
          </div>
          <div class="sb-form-block__subtitle" [class.cf-error]="showTaxCodeError || showFirstNameError || showLastNameError" [innerHTML]="'ENTITY.CUSTOMER-IDENTITY.NAMEWARNING' | translate"></div>
          <div class="sb-form-block__fields" formGroupName="customerIdentity">
            <div class="row">
              <div class="col-tb-4 col-xs-12">
                <wt-input-text lastPassHandler [validateOnBlur]="true" [label]="'ENTITY.CUSTOMER-IDENTITY.NAME' | translate" formControlName="firstName" [maxLength]="FormConstants.MAXIMUM_NAME_LENGTH"   [ngClass]="{'cf-error': showFirstNameError}" (input)="clearError('firstName')"></wt-input-text>
              </div>
              <div class="col-tb-4 col-xs-12">
                <wt-input-text lastPassHandler [validateOnBlur]="true" [label]="'ENTITY.CUSTOMER-IDENTITY.SURNAME' | translate" formControlName="lastName" [maxLength]="FormConstants.MAXIMUM_NAME_LENGTH" [ngClass]="{'cf-error': showLastNameError}" (input)="clearError('lastName')"></wt-input-text>
              </div>
              <div class="col-tb-4 col-xs-12 taxcode-container">
                <wt-input-text [validateOnBlur]="true" additionalClass="sb-transform-uppercase" [label]="'ENTITY.CUSTOMER-IDENTITY.FISCAL-CODE' | translate" [maxLength]="FormConstants.MAXIMUM_TAX_CODE_LENGTH" formControlName="taxCode"></wt-input-text>
                <div class="taxcode-tooltip">
                  <button (click)="toggleTooltip($event)" class="tooltip-icon">
                  </button>
                  <div *ngIf="showTooltip" class="tooltip-box" [innerHTML]="'ENTITY.CUSTOMER-IDENTITY.FISCAL-CODE-TOOLTIP-TEXT' | translate" (click)="$event.stopPropagation()">
                  </div>
                </div>
              </div>
              <div *ngIf="showTaxCodeError" class="taxcode-error">
                <div class="error-message">{{ 'ENTITY.CUSTOMER-IDENTITY.INVALID-TAX-CODE-ERROR-BOX' | translate }}</div>
              </div>
              <!-- <div *ngIf="formGroup.get('customerIdentity.taxCode').invalid && formGroup.get('customerIdentity.taxCode').touched" class="taxcode-error">
                <div class="error-message">{{ 'ENTITY.CUSTOMER-IDENTITY.INVALID-TAX-CODE-ERROR-BOX' | translate }}</div>
              </div> -->
              <div class="col-xs-12" *ngIf="shouldShowTaxCodeHelper">
                <div class="wt-text-base-m wt-margin-bottom-1">{{'STEP.CUSTOMER.FORGOT-TAX-CODE' | translate}}</div>
                <div class="wt-text-base-m"><a class="wt-link" (click)="calculateTaxCode()" tabindex="0" (keyup.Space)="calculateTaxCode()">{{'STEP.CUSTOMER.CALCULATE-TAX-CODE' | translate}}</a></div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="simType !== SIM_TYPES.IdleSim">
          <!-- region General Consents -->
          <div class="sb-form-block__fields" formGroupName="generalConsents">
            <div class="row" *ngIf="simType === SIM_TYPES.eSim">
              <div class="col-xs-12 flex wt-margin-bottom-4" >
                <wt-input-checkbox formControlName="eSimConditionsAccepted">
                  <div class="wt-text-light-m">
                    {{'ENTITY.CONSENTS.ESIM-CONSENTS' | translate}} (<a class="wt-link device-list-modalurl" (click)="showCompatibleDevices()" tabindex="0" (keyup.Space)="showCompatibleDevices()">Scopri i dispositivi compatibili</a>).
                  </div>
                </wt-input-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 flex wt-margin-bottom-4">
                <wt-input-checkbox formControlName="generalServiceConditionsAccepted">
                  <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.UNIQUE-CONSENTS' | translate:{ precontractUrl: precontractUrl }"></div>
                </wt-input-checkbox>
                <wt-info-note [showCloseButton]="true" [invert]="true" width="615px" class="flex__info-note" text="{{'ENTITY.CONSENTS.GENERAL-CONSENTS.TOOLTIP-TEXT' | translate}}"></wt-info-note>
              </div>
            </div>
            <!--  <div class="row" *ngIf="precontractUrl">
               <div class="col-xs-12 flex">
                 <wt-input-checkbox formControlName="precontractConditionsAccepted">
                   <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.PRE-CONTRACT' | translate:{ precontractUrl: precontractUrl }"></div>
                 </wt-input-checkbox>
               </div>
             </div> -->
            <div class="row">
              <div class="col-xs-12 flex">
                <div class="wt-text-light-m wt-margin-top-4 sb-color-grey-dark" [innerHTML]="'ENTITY.CONSENTS.GDPR' | translate"></div>
              </div>
            </div>
          </div>
          <!-- endregion -->
        </ng-container>
      </div>
    </div>
    <div class="sb-step__form__footer">
        <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="formGroupInvalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>
